import React, { useEffect, useMemo } from "react";
import { Row, Col, Button, ButtonGroup, Form, ListGroup } from "react-bootstrap";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { useState, useCallback } from "react";
import Highcharts from "highcharts";
import drilldown from "highcharts/modules/drilldown";
import HighchartsReact from "highcharts-react-official";
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import * as Icon from "react-bootstrap-icons";
import * as HighchartsExporting from 'highcharts/modules/exporting';
import { ThreeCircles } from "react-loader-spinner";
import { getFromLS } from '../../../utils/storage';
import Modal from "react-bootstrap/Modal";
import CustomEvents from "highcharts-custom-events";
import {
  ActionGrid
} from "./TaskDetailsGrids";
import {
  setPrimaryPieData,
  defaultDrilledPieData,
  extensionPieData,
  updateDrilledPie
} from "./TaskDetailsHelperFunctions";
import { TemplateDownloadRenderer } from "../TemplateDownloadRenderer";
import DropFileInput from "../../../reusable-components/DropFileComponent/DropFileComponent";
import OffCanvasNavbar from '../reportNavbar'
import { ReportGrid } from "../ReportGrid";
import { NoAccessPopup } from "../../../reusable-components/NoAccessPopupComponent/NoAccessModal";
import { TemplateDescriptionPopover } from "../TemplatePopoverlay";
require("highcharts/modules/accessibility")(Highcharts);
drilldown(Highcharts);
HighchartsExporting(Highcharts);
CustomEvents(Highcharts);
Highcharts.setOptions({
  lang: {
    thousandsSep: ','
  }
});

// Handling the action context menu
function upsert(array, element) { // (1)
  const i = array.findIndex(_element => _element.text === element.text);
  if (i > -1) array[i] = element; // (2)
  else array.push(element);
}
const Switch = ({ isToggled, onClick }) => {
  return (
    <label className="switch">
      <input type="checkbox" checked={isToggled} onChange={onClick} />
      <span className="slider round"></span>
    </label>
  );
};

const TaskDetailsReport = () => {
  // Set feature details to control access and get accessible features
  const featureName = "Task Details Report";
  const accessibleFeatures = getFromLS('active-features')

  // Check for access else return no access modal
  const [noAccessModalShow, setNoAccessModalShow] = useState(false)
  // if(!accessibleFeatures.includes(featureName)){
  //   return(
  //     <NoAccessPopup 
  //     featurename={featureName}
  //     />
  //   )
  // }

  // set user creds
  const [firm_id, setFirmId] = useState(getFromLS("firmId"));
  const [vendor, setVendor] = useState("xcm");

  // declare default grid params
  const [primaryRowData, setPrimaryRowData] = useState([]);

  // set loader params
  const [isLoading, setIsLoading] = useState(true);

  // set app params
  const localChartTheme = getFromLS('chart-theme');

  // set default data for chart and chips
  const [primarySeries, setPrimarySeries] = useState([])
  const [drilledSeries, setDrilledSeries] = useState([])
  const [extensionSeries, setExtensionSeries] = useState([])
  const [timeStampTask, setTimeStampTask] = useState("")
  const [timeStampExtension, setTimeStampExtension] = useState("")
  const [totalExtension, setTotalExtension] = useState("")
  const [totalTasks, setTotalTasks] = useState("")
  const [btns, setBtns] = useState(Highcharts.getOptions().exporting.buttons.contextButton.menuItems.slice())
  const [loaderText, setLoaderText] = useState(false);
  // set default API params
  const [reportApiResponse, setReportApiResponse] = useState({ "data": { "0": { "report": { "table_data": [] } } } });
  // set local mode params
  const [localApiResponse, setLocalApiResponse] = useState({
    data: { 0: { report: { staff: [] } } },
  });
  const [template_file_list, setTemplateFileList] = useState([]);
  const [templateDescription, setTemplateDescription] = useState("")
  const [localMode, setLocalMode] = useState(false);
  const [localLoaderToggle, setLocalLoaderToggle] = useState(true);


  /**
   * In this functionm, we pass the API response to extract template links to be displayed in local mode.
   * @param {*} result: API response.
   * @returns API response (for further use).
   */
  const setTemplateFiles = (result) => {
    setTemplateFileList(result.data[0].report.templates)
    setTemplateDescription("")
    console.log("TEMPLATE FILE LIST:", result.data[0].report.templates)
    return result
  }

  /**
   * This function enables the local mode and maintains the state of loaders and messages to be displayed.
   */
  const LocalModeEnabler = () => {
    setLocalLoaderToggle(true);
    if (localMode) {
      console.log("LOCAL MODE API RESPONSE: ", localApiResponse)
      setLoaderText(true);
      setApiData(reportApiResponse, false);
      setLocalLoaderToggle(false);
    }
    setLocalMode(!localMode);
  };

  const filesMap = {
    "TemplateProductionAndBilling": "",
    "TemplateStarStaff": ""
  }

  /**
   * This function accepts the uploaded template excel files and adds them to the payload for making Local Mode API call
   * @param {*} files 
   * @param {*} filename 
   */
  const onFileChange = (files, filename) => {
    console.log("FILENAME: ", filename)
    console.log("FILES: ", files)
    const formData = new FormData();
    if (filename == "TemplateTaskDetails") {
      filesMap.TemplateTaskDetails = files[0]
    }
    console.log("FILES: ", filesMap)
    if (filesMap.TemplateTaskDetails != "") {
      formData.append("file1", filesMap.TemplateTaskDetails);
      LocalModeApi(formData)
    } else {
      console.log("File should be uploaded for making local mode api call.")
    }
  };

  /**
   * This function takes the payload of uploaded excel files and makes the Local Mode API call
   * @param {*} formData: Payload.
   */
  const LocalModeApi = (formData) => {
    // updating payload for Local Mode API
    formData.append("report_name", "task_details");
    // This times out the loader till charts are generated
    if (formData) {
      setLoaderText(!loaderText);
      setTimeout(() => {
        setLocalLoaderToggle(false);
      }, 3000);
    }
    // call api and get data
    const requestOptions = {
      method: "POST",
      body: formData,
    };
    console.log("REQUEST OPTIONS: ", requestOptions);
    fetch(
      `${process.env.REACT_APP_BASE_URI}/api/local/get_reports/`,
      requestOptions
    )
      // API data recieved
      .then((result) => result.json())
      // Local Mode API data state maintained
      .then((result) => {

        console.log("LOCAL MODE API: ", result)
        if (result.success === true) {
          setLoaderText(!loaderText);
          setApiData(result, true)
          setTimeout(() => {
            setLocalLoaderToggle(false);
          }, 10000);
        } else {
          console.log("FAILED TO LOAD A LOCAL FILE!")
          setLocalLoaderToggle(true);
        }
      }
      ).catch(error => {
        console.error('ERROR IN LOCAL MODE API:', error);
      })
  }


  /**
   * This function is used for formatting the default column names of the grid
   * @param {*} defaultName: Current name from API
   * @returns: Final column name
   */
  const GridColumnTitleRenderer = (defaultName) => {
    const splitWords = defaultName.split("_")
    for (let word in splitWords) {
      splitWords[word] = splitWords[word].charAt(0).toUpperCase() + splitWords[word].slice(1)
    }
    return splitWords.join(" ")
  }

  /**
   * This function takes the API response data and maps it to the grid params
   * @param {*} result: API response
   */
  const gridParamsMapper = (result) => {
    console.log("GRID PARAM MAPPER RESULT:", result)
    if (result.data[0].report.table_data.length != 0) {
      const keys = Object.keys(result.data[0].report.table_data[0]) // You need to change this based on API response format in every report
      let jsonColDefs = keys.map(key => {
        return {
          field: key, headerName: GridColumnTitleRenderer(key)
        }
      });
      setColDefs(jsonColDefs)
    }
    setRowData(result.data[0].report.table_data);

    if (result.data[0].report.extensions.length != 0) {
      const keys = Object.keys(result.data[0].report.extensions[0]) // You need to change this based on API response format in every report
      let extensionJsonColDefs = keys.map(key => {
        return {
          field: key, headerName: GridColumnTitleRenderer(key)
        }
      });
      setExtensionColDefs(extensionJsonColDefs)
    }
    setExtensionRowData(result.data[0].report.extensions);
  }

  // maitain api response
  const setApiData = (result, localMode = false) => {
    console.log("API DATA: ", result)
    if (localMode) {
      setLocalApiResponse(result);
      // Extension grid data set below
      setExtensionRowData(result.data[0].report.extensions)
      setPrimaryRowData(result.data[0].report.table_data)
      console.log("BEFORE UPDATING: ", [primaryseries, timestamptask, timestampextension, totalextension, totaltasks])
      [primaryseries, timestamptask, timestampextension, totalextension, totaltasks] = setPrimaryPieData(result)
      defaultdrilleddata = defaultDrilledPieData(result)
      extensionseries = extensionPieData(result)
      console.log("AFTER UPDATING: ", [primaryseries, timestamptask, timestampextension, totalextension, totaltasks])
    } else {
      setReportApiResponse(result);
      // Extension grid data set below
      setExtensionRowData(result.data[0].report.extensions)
      setPrimaryRowData(result.data[0].report.table_data)
    }
    gridParamsMapper(result)
    return result;
  };


  const [rowData, setRowData] = useState([]);
  const [colDefs, setColDefs] = useState([]);
  const [extensionRowData, setExtensionRowData] = useState([]);
  const [extensionColDefs, setExtensionColDefs] = useState([]);

  let gridApi;
  const onGridReady = useCallback((params) => {
    gridApi = params.api
    gridApi.closeToolPanel();
  }, []);

  let extensionGridApi;
  const onExtensionGridReady = useCallback((params) => {
    extensionGridApi = params.api
    extensionGridApi.closeToolPanel();
  }, []);


  // call api and get data 
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ firm_id, vendor }),
  };

  const getTaskDetails = () => {
    fetch(
      `${process.env.REACT_APP_BASE_URI}/api/report/task_details/`,
      requestOptions
    )
      // API data recieved
      .then((result) => result.json())
      // API data state maintained
      .then((result) => setApiData(result))
      .then((result) => (setTemplateFiles(result)))
      // Grid data set below
      .then((result) => setRowData(result.data[0].report.table_data))
  }

  // get actionable grid reference
  let contextGridApi;
  const onContextGridReady = useCallback((params) => {
    contextGridApi = params.api
    contextGridApi.closeToolPanel();
  })

  // process data to get chart data
  let [primaryseries, timestamptask, timestampextension, totalextension, totaltasks] = setPrimaryPieData(reportApiResponse);
  let defaultdrilleddata = defaultDrilledPieData(reportApiResponse);
  let extensionseries = extensionPieData(reportApiResponse);

  // setting default chart data
  useEffect(() => {
    console.log("VALUES ARE BEING UPDATED? :", [timestamptask, timestampextension, totalextension, totaltasks])
    setIsLoading(true)
    setPrimarySeries(primaryseries)
    setTimeStampTask(timestamptask)
    setTimeStampExtension(timestampextension)
    setTotalExtension(totalextension)
    setTotalTasks(totaltasks)
    setDrilledSeries(defaultdrilleddata)
    setExtensionSeries(extensionseries)
  }, [timestamptask, timestampextension, totalextension, totaltasks])

  // actions on task details data
  const emailSelectedClients = () => {
    let selectedData = contextGridApi.getSelectedRows();
    const namelist = []
    for (let obj in selectedData) {
      namelist.push(selectedData[obj]["ClientName"])
    }
    alert("Email has been sent to:" + namelist);
    return selectedData;
  };

  const fileExtensionForSelectedClients = () => {
    let selectedData = contextGridApi.getSelectedRows();
    const namelist = []
    for (let obj in selectedData) {
      namelist.push(selectedData[obj]["ClientName"])
    }
    alert("Filed extensions for:" + namelist);
    return selectedData;
  };

  const deactivateSelectedClients = () => {
    let selectedData = contextGridApi.getSelectedRows();
    const namelist = []
    for (let obj in selectedData) {
      namelist.push(selectedData[obj]["ClientName"])
    }
    alert("Deactivated:" + namelist);
    return selectedData;
  };

  // grid export functionality
  const onBtExcelExport = useCallback(() => {
    gridApi.exportDataAsExcel();
  }, []);

  const onBtCSVExport = useCallback(() => {
    gridApi.exportDataAsCsv();
  }, []);

  // handle actions on data with actionable grid params
  const [modalShow, setModalShow] = useState(false);
  const [contextHeader, setContextHeader] = useState("");
  const [contextRowData, setContextRowData] = useState([]);
  const takeAction = () => { setModalShow(true) }

  // Actionable popup
  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered
        className="action-modal"
      >
        <Modal.Header closeButton>
          <div className="toggler">
            <span style={{ color: "var(--text_color)", fontWeight: "700" }}> Return Status Rollup: {contextHeader} &nbsp; &nbsp;</span>
          </div>
        </Modal.Header>
        <Modal.Body className="show-grid">
          <Row>
            <Col md="12" className="grid-row staffing">
              <ActionGrid
                rowData={contextRowData}
                onGridReady={onContextGridReady}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="action-footer">
          {/* <div>
            <span style={{ color: "var(--text_color)" }}><Icon.EnvelopeAtFill /> - Send alert email &nbsp;</span>
            <span style={{ color: "var(--text_color)" }}><Icon.Journals /> -  &nbsp;</span>
            <span style={{ color: "var(--text_color)" }}><Icon.XCircleFill /> -  &nbsp;</span>
          </div> */}
          <div className="right action-buttons ">
            <Button variant="secondary" onClick={emailSelectedClients}><Icon.EnvelopeAtFill /> Send alert email</Button>&nbsp;&nbsp;&nbsp;
            <Button variant="secondary" onClick={fileExtensionForSelectedClients}><Icon.Journals /> File extension</Button>&nbsp;&nbsp;&nbsp;
            <Button variant="secondary" onClick={deactivateSelectedClients}><Icon.XCircleFill /> Deactivate account</Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  // interactive primary chart
  const primaryOptions = {
    chart: {
      type: "pie",
      height: 500,
      backgroundColor: "var(--card_body_color)",
      color: "var(--text_color)"
    },
    marginRight: -100,
    title: {
      align: "center",
      text: "Return status rollup",
      style: {
        textOutline: false,
        color: "var(--text_color)"
      }
    },
    subtitle: {
      align: "center",
      text: "Double click to view detailed tasks",
      style: {
        textOutline: false,
        color: "var(--text_color)"
      }
    },
    accessibility: {
      announceNewData: {
        enabled: true,
      },
    },
    xAxis: {
      type: "category",
      labels: {
        style: {
          textOutline: false,
          color: "var(--text_color)"
        }
      }
    },
    yAxis: {
      title: {
        text: "Hours",
        textOutline: false,
        color: "var(--text_color)"
      },
      labels: {
        style: {
          textOutline: false,
          color: "var(--text_color)"
        }
      }
    },
    colors: localChartTheme.colors,
    legend: {
      itemStyle: {
        textOutline: false,
        color: "var(--text_color)"
      },
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: "{point.y:,.0f}",
          colorByPoint: true,
          style: {
            textOutline: false,
            color: "var(--text_color)"
          },
        },
        size: "75%",
        innerSize: "35%",
        showInLegend: {
          enabled: true,
        },
        cursor: "pointer",
        events: {
          click: function (event) {
            event.preventDefault();
            setContextHeader(event.point.name);
            let [rowdata, drld_series] = updateDrilledPie(event.point.name, reportApiResponse);
            if (event.point.name != [] || event.point.name != undefined) {
              const ta_btn = {
                text: 'Take actions',
                onclick: function () {
                  takeAction(event.point.name)
                }
              }
              upsert(btns, ta_btn)
            }
            setRowData(rowdata)
            setDrilledSeries(drld_series)
            setContextRowData(rowdata)
            setBtns(btns)
          },
          dblclick: function (event) {
            event.preventDefault();
            console.log("doubleclick event", event.toElement.point.name)
            setContextHeader(event.toElement.point.name)
            let [rowdata, drld_series] = updateDrilledPie(event.toElement.point.name, reportApiResponse);
            console.log("doubleclick ROWDATA", drld_series)
            console.log("doubleclick series", drld_series)
            if (event.toElement.point.name != [] || event.toElement.point.name != undefined) {
              const ta_btn = {
                text: 'Take actions',
                onclick: function () {
                  takeAction(event.toElement.point.name)
                }
              }
              upsert(btns, ta_btn)
            }
            setRowData(rowdata)
            setDrilledSeries(drld_series)
            setContextRowData(rowdata)
            setBtns(btns)
          },
          contextmenu: function (event) {
            event.preventDefault();
            console.log("rightclick event", event.srcElement.point.name)
            setContextHeader(event.srcElement.point.name)
            let [rowdata, drld_series] = updateDrilledPie(event.srcElement.point.name, reportApiResponse);
            if (event.srcElement.point.name != [] || event.srcElement.point.name != undefined) {
              const ta_btn = {
                text: 'Take actions',
                onclick: function () {
                  takeAction(event.srcElement.point.name)
                }
              }
              upsert(btns, ta_btn)
            }
            setRowData(rowdata)
            setDrilledSeries(drld_series)
            setContextRowData(rowdata)
            setBtns(btns)
            takeAction(event.srcElement.point.name)
          }
        },
      },
    },
    tooltip: {
      headerFormat: '<span style="font-size: var(--default)">{series.name}</span><br>',
      pointFormat:
        '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:,.0f}</b> of total<br/>',
    },
    exporting: {
      enabled: true,
      chartOptions: {
        xAxis: [{
          max: null
        }]
      }
    },
    series: primarySeries,
  };

  // drilled interactive + actionable pie
  const drilledOptions = {
    chart: {
      type: "pie",
      height: 500,
      backgroundColor: "var(--card_body_color)",
      color: "var(--text_color)"
    },
    colors: localChartTheme.colors,
    title: {
      align: "center",
      text: "Return status",
      style: {
        textOutline: false,
        color: "var(--text_color)"
      }
    },
    accessibility: {
      announceNewData: {
        enabled: true,
      },
    },
    xAxis: {
      type: "category",
      labels: {
        style: {
          textOutline: false,
          color: "var(--text_color)"
        }
      }
    },
    yAxis: {
      title: {
        text: "Hours",
        style: {
          textOutline: false,
          color: "var(--text_color)"
        }
      },
      labels: {
        style: {
          textOutline: false,
          color: "var(--text_color)"
        }
      }
    },
    legend: {
      itemStyle: {
        textOutline: false,
        color: "var(--text_color)"
      },
      maxHeight: 100
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        marginLeft: -100,
        dataLabels: {
          enabled: true,
          format: "{point.y:,.0f}",
          colorByPoint: true,
          style: {
            textOutline: false,
            color: "var(--text_color)"
          },
        },
        size: "75%",
        innerSize: "35%",
        showInLegend: {
          enabled: true,
        },
        cursor: "pointer",
      },
    },
    tooltip: {
      headerFormat: '<span style="font-size: var(--default)">{series.name}</span><br>',
      pointFormat:
        '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:,.0f}</b> of total<br/>',
    },
    exporting: {
      enabled: true,
      chartOptions: {
        xAxis: [{
          max: null
        }]
      },
      buttons: {
        contextButton: {
          menuItems: btns
        }
      }
    },
    series: drilledSeries,
  };

  // extensions chart
  const tertiaryOptions = {
    chart: {
      type: "pie",
      height: 500,
      backgroundColor: "var(--card_body_color)",
      color: "var(--text_color)"
    },
    title: {
      align: "center",
      text: "Extension details",
      style: {
        textOutline: false,
        color: "var(--text_color)"
      }
    },
    accessibility: {
      announceNewData: {
        enabled: true,
      },
    },
    colors: localChartTheme.colors,
    xAxis: {
      type: "category",
      labels: {
        style: {
          textOutline: false,
          color: "var(--text_color)"
        }
      }
    },
    legend: {
      itemStyle: {
        textOutline: false,
        color: "var(--text_color)"
      },
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        marginLeft: -100,
        dataLabels: {
          enabled: true,
          format: "{point.y:,.0f}",
          colorByPoint: true,
          style: {
            textOutline: false,
            color: "var(--text_color)"
          },
        },
        size: "75%",
        innerSize: "35%",
        showInLegend: {
          enabled: true,
        },
        cursor: "pointer",
      },
    },
    tooltip: {
      headerFormat: '<span style="font-size: var(--default)">{series.name}</span><br>',
      pointFormat:
        '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:,.0f}</b> of total<br/>',
    },
    exporting: {
      enabled: true,
      chartOptions: {
        xAxis: [{
          max: null
        }]
      }
    },
    series: extensionSeries,
  };

  // chart and grid reset functionality
  let handleReset = (e) => {
    e.preventDefault();
    setRowData(primaryRowData)
    setDrilledSeries(defaultdrilleddata)
    setBtns(Highcharts.getOptions().exporting.buttons.contextButton.menuItems.slice())
  }

  const loader = primarySeries != [] && timeStampTask && timeStampExtension && totalExtension && totalTasks && drilledSeries != [] && extensionSeries != []

  useEffect(() => {
    if (loader) {
      setIsLoading(false);
      setTimeout(() => {
        setLocalLoaderToggle(false);
        setLoaderText(true);
      }, 2000);
    }
  }, [loader]);



  if (isLoading) {
    getTaskDetails()
    return (
      <div>
        <Row className="dashboard-row">
          <div className="spinner"
          >
            <ThreeCircles
              height="100"
              width="100"
              color=""
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
              ariaLabel="--theme1_primary"
              outerCircleColor="var(--theme1_primary)"
              innerCircleColor="var(--theme1_tertiary)"
              middleCircleColor="var(--theme1_quarternary)"
            />
            <h5
              style={{
                position: "relative",
                left: "-5%",
                padding: "10px",
              }}
            >
              Loading your task details dashboard
            </h5>
          </div>
        </Row>
      </div>
    )
  }

  return (
    <>
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      <div className="row-wrapper">
        <div className="row-container">
          {localMode ? (
            <>
              <h3 className="intelligence-report-name">{featureName}</h3>
              <Row className="local-import-row">
                <Col md={2} style={{ paddingLeft: 0, paddingRight: 0 }}>
                  <p style={{ color: "#000", fontWeight: "900", marginBottom: 10, marginRight: 20 }}> Download templates
                    <TemplateDescriptionPopover
                      description={templateDescription}
                    />
                  </p>
                  <Row className="no-gutter">
                    {
                      template_file_list && template_file_list.map((object, index) => (
                        <TemplateDownloadRenderer info={object} key={index} />
                      )
                      )
                    }
                  </Row>
                </Col>
                {
                  template_file_list && template_file_list.map((object, index) => (
                    object.send_back
                      ?
                      <Col md={10} key={index}>
                        <DropFileInput onFileChange={(files) => onFileChange(files, object.name)} message={`Drag and drop ${object.name + "." + object.extension} file here`} />
                      </Col>
                      :
                      <></>
                  )
                  )
                }
              </Row>
            </>
          ) : (
            <>
              <h3 className="intelligence-report-name">{featureName}</h3>
              <Row className="report-card-row">
                <div className="report-card">
                  <div className="chip-header">
                    Total tasks
                  </div>
                  <div className="chip-body">
                    {totalTasks}
                  </div>
                </div>
                <div className="report-card">
                  <div className="chip-header">
                    Total extensions
                  </div>
                  <div className="chip-body">
                    {totalExtension}
                  </div>
                </div>
                <div className="report-card">
                  <div className="chip-header">
                    Tasks timestamp
                  </div>
                  <div className="chip-body">
                    {timeStampTask}
                  </div>
                </div>
                <div className="report-card">
                  <div className="chip-header">
                    Extension timestamp
                  </div>
                  <div className="chip-body">
                    {timeStampExtension}
                  </div>
                </div>
              </Row>
            </>
          )}
        </div>
      </div>

      <div className="row-wrapper">
        <div className="row-container">
          <Tabs
            defaultActiveKey="chart"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="chart" title="Chart" className="tabs">
              <OffCanvasNavbar
                localtoggle={
                  <ButtonGroup>
                    <div className="toggler">
                      {localMode ? (
                        <p style={{ color: "#000", fontWeight: "500" }}>
                          Go back online
                        </p>
                      ) : (
                        <p style={{ color: "#000", fontWeight: "500" }}>
                          Switch to local mode
                        </p>
                      )}
                    </div>
                    <div className="toggler">
                      <Switch
                        isToggled={localMode}
                        onClick={() => LocalModeEnabler()}
                      ></Switch>
                    </div>
                  </ButtonGroup>
                }
                secondtoggle={
                  <DropdownButton as={ButtonGroup} onClick={handleReset} className='reset-button' title=" Reset">
                  </DropdownButton>
                }
              />

              <Row>
                <Col md="4">
                  {localLoaderToggle ? (
                    <div className="chart-container chart-loader">
                      <ThreeCircles
                        height="300"
                        width="300"
                        color=""
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel="--theme1_primary"
                        outerCircleColor="var(--theme1_primary)"
                        innerCircleColor="var(--theme1_tertiary)"
                        middleCircleColor="var(--theme1_quarternary)"
                      />
                      <br />
                      {loaderText ? (
                        <h5
                          style={{
                            position: "relative",
                            padding: "10px",
                          }}
                        >
                          Waiting for you to upload an excel file!
                        </h5>
                      ) : (
                        <h5
                          style={{
                            position: "relative",
                            padding: "10px",
                          }}
                        >
                          Loading your chart!
                        </h5>
                      )}
                    </div>
                  ) : (
                    <div className="chart-container">
                      <HighchartsReact highcharts={Highcharts} options={primaryOptions} />
                    </div>
                  )}
                </Col>
                <Col md="4">{localLoaderToggle ? (
                  <div className="chart-container chart-loader">
                    <ThreeCircles
                      height="300"
                      width="300"
                      color=""
                      wrapperStyle={{}}
                      wrapperClass=""
                      visible={true}
                      ariaLabel="--theme1_primary"
                      outerCircleColor="var(--theme1_primary)"
                      innerCircleColor="var(--theme1_tertiary)"
                      middleCircleColor="var(--theme1_quarternary)"
                    />
                    <br />
                    {loaderText ? (
                      <h5
                        style={{
                          position: "relative",
                          padding: "10px",
                        }}
                      >
                        Waiting for you to upload an excel file!
                      </h5>
                    ) : (
                      <h5
                        style={{
                          position: "relative",
                          padding: "10px",
                        }}
                      >
                        Loading your chart!
                      </h5>
                    )}
                  </div>
                ) : (
                  <div className="chart-container">
                    <HighchartsReact highcharts={Highcharts} options={drilledOptions} />
                  </div>)}
                </Col>
                <Col md="4">
                  {localLoaderToggle ? (
                    <div className="chart-container chart-loader">
                      <ThreeCircles
                        height="300"
                        width="300"
                        color=""
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel="--theme1_primary"
                        outerCircleColor="var(--theme1_primary)"
                        innerCircleColor="var(--theme1_tertiary)"
                        middleCircleColor="var(--theme1_quarternary)"
                      />
                      <br />
                      {loaderText ? (
                        <h5
                          style={{
                            position: "relative",
                            padding: "10px",
                          }}
                        >
                          Waiting for you to upload an excel file!
                        </h5>
                      ) : (
                        <h5
                          style={{
                            position: "relative",
                            padding: "10px",
                          }}
                        >
                          Loading your chart!
                        </h5>
                      )}
                    </div>
                  ) : (
                    <div className="chart-container">
                      <HighchartsReact highcharts={Highcharts} options={tertiaryOptions} />
                    </div>)}
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="grid" title="Grid" className="tabs">
              <DropdownButton as={ButtonGroup} className='reset-button download-excel' title=" Export" id="bg-nested-dropdown" drop="start">
                <Dropdown.Item onClick={onBtExcelExport}> <Icon.FileExcel /> Excel Export</Dropdown.Item>
                <Dropdown.Item onClick={onBtCSVExport}> <Icon.FiletypeCsv /> CSV Export</Dropdown.Item>
              </DropdownButton>
              <Row>
                <Col md="12" className="grid-row staffing">
                  <ReportGrid
                    rowData={rowData}
                    colDefs={colDefs}
                    onGridReady={onGridReady}
                  />
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="extension-grid" title="Extension Grid" className="tabs">
              <DropdownButton as={ButtonGroup} className='reset-button download-excel' title=" Export" id="bg-nested-dropdown" drop="start">
                <Dropdown.Item onClick={onBtExcelExport}> <Icon.FileExcel /> Excel Export</Dropdown.Item>
                <Dropdown.Item onClick={onBtCSVExport}> <Icon.FiletypeCsv /> CSV Export</Dropdown.Item>
              </DropdownButton>
              <Row>
                <Col md="12" className="grid-row staffing">
                  <ReportGrid
                    rowData={extensionRowData}
                    colDefs={extensionColDefs}
                    onGridReady={onExtensionGridReady}
                  />
                </Col>
              </Row>
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default TaskDetailsReport;
